import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

export type UserDateFormatOptions = {
  isTime?: boolean;
  isYear?: boolean;
  isComma?: boolean;
};

export const useUserDateFormat = (options: UserDateFormatOptions = {}) => {
  const { isYear = false, isComma = false } = options;
  const userDetails = useSelector(
    (state: RootState) => state.counter.userDetails
  );

  const userDateFormat = useMemo(() => {
    let dateFormat = 'DD/MM/YYYY';
    if (userDetails?.date_format === 'DD/MM/YYYY') {
      dateFormat = isYear
        ? `DD MMM`
        : isComma
        ? `DD MMM, YYYY`
          : `DD MMM YYYY`;
    } else if (userDetails?.date_format === 'MM/DD/YYYY') {
      dateFormat = isYear
        ? `MMM DD`
        : isComma
        ? `MMM DD, YYYY`
        : `MMM DD YYYY`;
    }
    return dateFormat;
  }, [userDetails]);
  return {
    userDateFormat
  };
};
